<template>
  <el-table-column
    prop="prefix"
    label="Előtag"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.prefix || '-' }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'prefix',
  };
</script>
